export default size => {
  const i = Math.floor(Math.log(size) / Math.log(1024));

  // eslint-disable-next-line no-restricted-properties
  return `${(size / Math.pow(1024, i)).toFixed(2) * 1} ${
    ['B', 'kB', 'MB', 'GB', 'TB'][i]
  }`;
};
